import { DvToolbarAction } from '@devinco/ui/grid';
import { inject, Injectable } from '@angular/core';
import { ColumnType } from '@features/vt-grid/grid-options/column-types';
import { ColDef } from 'ag-grid-community';
import { getStandardActionPreset } from '@features/vt-grid/presets/preset-actions';
import { DvSplitterEventsService } from '@devinco/ui/dds/splitter';
import { RouteNetwork } from '@shared/interfaces/route-network';

@Injectable({ providedIn: 'root' })
export class RouteNetworksGridService {
  private splitterEvents = inject(DvSplitterEventsService);

  getColDefs = (): ColDef<RouteNetwork>[] => [
    {
      field: 'RouteNetworkID',
      headerName: 'RouteNetworksGrid.RouteNetworkID',
      type: [ColumnType.Id],
      initialHide: true,
    },
    {
      field: 'Name',
      headerName: 'RouteNetworksGrid.Name',
      type: [ColumnType.Text],
      width: 350,
    },
    {
      field: 'Description',
      headerName: 'RouteNetworksGrid.Description',
      type: [ColumnType.Text],
    },
  ];

  getToolbarActions = (): DvToolbarAction[] => [
    ...getStandardActionPreset(),
    {},
    {
      icon: 'edit',
      disabled: true,
      tooltipKey: 'Grid.Edit',
      clickFn: () => this.splitterEvents.isSplitterOpened$.next(true),
    },
  ];
}
